import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

import CruisePurchaseAddOnsTable from './add-ons-table';
import CruisePurchaseItemDetailTable from './detail-table';
import CruisePurchaseGuestTable from './guest-table';
import { ScheduleCardHeader } from '../../../style';

interface Props {
  parentIndex: number;
}

export default function CruiseGuestCard(props: Props) {
  const { t } = useTranslation();

  return (
    <CardSection>
      <ScheduleCardHeader $style={style}>
        <Text variant="HeadingXSmall">
          {t('ticketSales:guest_detail')} {props.parentIndex + 1}
        </Text>
        <Input
          type="check-box"
          name={`approvalable.cruisePurchases.${props.parentIndex}.isGroupedPrice`}
          label={t('ticketSales:grouped_price')}
          noMargin
        />
      </ScheduleCardHeader>
      <Separator gap={24} />
      <CruisePurchaseGuestTable parentIndex={props.parentIndex} />
      <Separator gap={24} />
      <CruisePurchaseItemDetailTable parentIndex={props.parentIndex} />

      <CruisePurchaseAddOnsTable parentIndex={props.parentIndex} />
    </CardSection>
  );
}

const style: StyleObject | any = {
  flexDirection: 'column',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
};
